import React from 'react';
import castelinoImage from '../../../../src/assets/images/castelino.jpg';
import './Castelino.styled.css';


const CastelinoSection = () => {
    return (
        <section className="flex items-center flex-col md:flex-row w-full castelino-section">
        <div className="h-full w-full ml-0 flex justify-center items-center md:ml-8 mb-4 md:mb-0 md:w-2/5 py-4">
            <img src={castelinoImage} alt="Castelino Cheese" className="castelino-section-img object-cover h-full w-full rounded" />
        </div>

        <div className="w-full md:w-3/5 flex flex-col items-center justify-center mt-4 px-6 md:px-12 md:p-0">
            <div className="w-full rounded-lg text-center myzithra-info px-6 md:px-12">
                <h1 className="text-2xl md:text-5xl font-bold text-[#DC143C] text-gray-900">Grill Cheese 'Elikon' <br/> The Perfect Cheese for Cooking</h1>
                <p className="mt-6 text-m md:text-xl text-gray-700 flex items-center">
                Grill cheese 'Elikon' is crafted from sheep’s and goat’s milk, specifically designed to maintain its shape when heated without melting completely. Its firm texture and high melting point make it ideal for grilling, frying, or baking.                </p>
                
                <p className="text-m md:text-xl text-gray-700 flex items-center">
                When cooked, this cheese develops a golden, crisp crust on the outside while becoming soft and creamy on the inside. Its mild, slightly salty flavor pairs wonderfully with fresh salads, grilled vegetables, or sauces, making it a versatile option for vegetarians and a staple in both casual and gourmet meals.
                </p>
            </div>
        </div>
        
    </section>
    );
};

export default CastelinoSection;
